import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="accordion"
export default class extends Controller {
  static values = {
    theme: String,
  };
  static targets = ["questionZone", "answerZone", "chevron"];

  declare questionZoneTarget: HTMLElement;
  declare answerZoneTarget: HTMLElement;
  declare chevronTarget: HTMLElement;
  declare themeValue: String;

  toggleAccordion() {
    this.answerZoneTarget.classList.toggle("hidden");
    this.chevronTarget.classList.toggle("rotate-180");
    this.themeValue.split(" ").forEach((className) => {
      this.questionZoneTarget.classList.toggle(className);
    });
  }
}
